import * as i0 from "@angular/core";
export class CacheRequest {
}
const maxAge = 1800000; // maximum cache age (ms) 1800000 => 30 mins
export class CacheRequestService {
    //cache: { [name: string]: AsyncSubject<HttpEvent<any>> } = {};
    constructor() {
        this.cachedData = new Map();
        //this.loadCacheData();
    }
    get(url) {
        const cached = this.cachedData.get(url);
        if (!cached || cached.lastUpdated < (Date.now() - maxAge)) {
            console.log('cache:get', url, 'not');
            return undefined;
        }
        console.log('cache:get', url, this.cachedData);
        return cached.response;
    }
    set(url, response) {
        console.log('cache:set', url, this.cachedData);
        const entry = { url, response, lastUpdated: Date.now() };
        this.cachedData.set(url, entry);
        this.removeExpired();
    }
    delete(url, useLikePattern = false) {
        if (useLikePattern) {
            const urlBase = url.split("?")[0];
            this.cachedData.forEach(entry => {
                const urlBaseCached = entry.url.split("?")[0];
                if (urlBaseCached == urlBase) {
                    this.cachedData.delete(entry.url);
                    console.log('cache:del', url, useLikePattern, urlBaseCached);
                }
            });
        }
        else {
            const cached = this.cachedData.get(url);
            if (cached) {
                console.log('cache:del', url, useLikePattern);
            }
            this.cachedData.delete(url); //ToDo V improve if pending
        }
    }
    removeExpired() {
        const expirationDate = Date.now() - maxAge;
        this.cachedData.forEach(entry => {
            if (entry.lastUpdated <= expirationDate) {
                this.cachedData.delete(entry.url);
            }
        });
    }
}
CacheRequestService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CacheRequestService_Factory() { return new CacheRequestService(); }, token: CacheRequestService, providedIn: "root" });
